<div class="smp-grid-column-header mat-typography">
    <button id="widget_header.btn.action"
            *ngIf="params.column.colId === 'selected'"
            mat-icon-button 
            (click)="btnClicked()">
        <mat-icon>{{ params.agMatIconName }}</mat-icon>
    </button>

    <span *ngIf="params.column.colId !== 'selected'">{{ params.displayName }}</span>
</div>

